import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {LoginProvider} from "../providers/login/login";

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ]
})
export class TokenInterceptorModule implements HttpInterceptor {

  constructor(private loginProvider: LoginProvider) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.indexOf('/api/') > -1) {
      const newHeaders = {
        'Accept': 'application/json',
      };

      if (this.loginProvider.userToken) {
        newHeaders['Authorization'] = `Bearer ${this.loginProvider.userToken}`;
      }

      if (!req.headers.has('Content-Type')) {
        newHeaders['Content-Type'] = 'application/json';
      }

      req = req.clone({
        setHeaders: newHeaders
      });
    }
    return next.handle(req);
  }
}



// WEBPACK FOOTER //
// ./src/interceptors/token-interceptor.module.ts